/**
 * Quantas colunas a faixa de indicadores desenha (p.17; R01 p.28).
 *
 * A faixa se REORGANIZA em vez de espremer: com o card mais estreito que o
 * que ele pede (o valor inteiro, o rotulo numa linha e o contexto legivel),
 * ela cai de coluna. As regras:
 *
 *  - QUATRO TRILHAS quando quatro cards cabem — mesmo com menos cards. Um ou
 *    dois cards ficam na largura e no alinhamento de uma faixa cheia, com as
 *    vagas do fim vazias; nao se esticam pela tela ("3.030" num canto e 900 px
 *    vazios) nem desalinham da faixa de quatro logo acima.
 *  - Quatro cards caem para DUAS (2 x 2), nunca para tres: 3 + 1 solto.
 *  - Tres cards caem para TRES e dai direto para UMA: 2 + 1 deixava um card
 *    orfao na segunda fileira.
 *  - Um ou dois cards caem para duas e para uma.
 */
export function trilhasDaFaixa({
  largura,
  quantidade,
  minimo,
  vao,
}: {
  /** Largura util da faixa, em px. */
  readonly largura: number;
  /** Quantos cards (no maximo quatro, p.17). */
  readonly quantidade: number;
  /** A largura que o card mais exigente pede, em px. */
  readonly minimo: number;
  /** O vao entre cards, em px. */
  readonly vao: number;
}): number {
  const cabem = (colunas: number) => colunas * minimo + (colunas - 1) * vao <= largura;
  if (cabem(4)) return 4;
  if (quantidade === 3) return cabem(3) ? 3 : 1;
  if (quantidade === 4 || quantidade <= 2) return cabem(2) ? 2 : 1;
  return 1;
}

/**
 * A coluna de texto do card nunca fica mais estreita que isto, em px. E o que
 * deixa o contexto ("R$ 5.062,01 de gasto; fora dele, 8 lancamentos sem
 * preco") em ate duas ou tres linhas, e nao num parágrafo de quatro linhas de
 * 132 px — o "espremido" da faixa a 1024 e a 1280. Multiplo de 4 (p.13).
 */
export const COLUNA_DE_TEXTO_MINIMA = 180;

/** Arredonda para cima, no multiplo de 4 (p.13). */
export function multiploDeQuatro(px: number): number {
  return Math.ceil(px / 4) * 4;
}
